import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { startSessionTimer, clearSessionTimer } from './sessionTimeout';
import apiClient from '../../api/apiClient';
import tenantStorage from '../../utils/tenantStorage';

const SessionTimeoutHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      try {
        await apiClient.post('/logout');
      } catch (e) {}
      tenantStorage.clear();
      clearSessionTimer();
      navigate('/login', { state: { mode: 'SESSION_INACTIVE' } });
    };

    startSessionTimer(logout);

    const resetAndRestart = () => {
      clearSessionTimer();
      startSessionTimer(logout);
    };
    ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event => {
      window.addEventListener(event, resetAndRestart, true);
    });

    return () => {
      clearSessionTimer();
      ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach(event => {
        window.removeEventListener(event, resetAndRestart, true);
      });
    };
  }, [navigate]);

  return null;
};

export default SessionTimeoutHandler;